import { render, staticRenderFns } from "./TargetUser.vue?vue&type=template&id=8c1faff8&"
import script from "./TargetUser.vue?vue&type=script&lang=js&"
export * from "./TargetUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports